import { render, staticRenderFns } from "./OrderEvaluationByResearcher.vue?vue&type=template&id=22fa0a6e"
import script from "./OrderEvaluationByResearcher.vue?vue&type=script&lang=js"
export * from "./OrderEvaluationByResearcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports